import { pushState } from './url-utils';

export const parseURLSearchParams = (): Record<string, string> => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlSearchParamsFromHash = new URLSearchParams(window.location.hash.substring(1));

  const params = {};
  urlSearchParams.forEach((value, key) => {
    params[key] = value;
  });

  urlSearchParamsFromHash.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

export const pushParamsToHistory = (params: Record<string, string>, path = window.location.pathname, state = {}, replaceState = false): void => {
  pushState(path, params, state, replaceState);
};
